import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/tenant/TenantFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/tenant/TenantHeader.tsx");
